"use strict";

var $ = require("jquery");
var ApiUser = require("../../ApiUser");
var Cookies = require("cookies-js");
var common = require("../../common");

function MakeupsInfoPage(frontend) {
	this.state = {
		frontend: frontend
	};
}


MakeupsInfoPage.prototype.load = function(cb) {
	var api_user = this.state.frontend.state.api_user;

	$("#quick-access").hide();
	
	api_user.fetch_data("/student/attendance/get_makeup_info", null, function(err, res) {
		console.log(res);
		$(".content").append(res);
		cb();
	});


};

module.exports = MakeupsInfoPage;
